import React from 'react';
import { observer } from "mobx-react";
import uniqueId from 'lodash/uniqueId';
import { Icon } from 'components/Icon';
import { PromptIcon } from 'components/Svg';
import MenuItem from '../Menu/MenuItem';
import AdminMenuGroup from '../Menu/AdminMenuGroup';
import EcommerceMenu from '../Menu/EcommerceMenu';
import { DataMenu } from '../Menu/AdminMenuGroup';
import consoleStore from 'stores/Console/ConsoleStore';
import constants from 'Constants';
import * as auth from 'Auth';
import * as paths from 'Paths';
import * as utils from 'Utils';
import './styles.scss';




@observer
class OverviewMenu extends React.Component {
  constructor (props) {
    super(props);
    this.overviewUrl = paths.getPathPromptOverview();
  }

  componentDidMount() {
    let isActive = this.checkIsActive();
    if (isActive) {
      this.props.updateActiveMenu(constants.PROMPT_MENU.OVERVIEW);
    }
  }

  checkIsActive = () => {
    const { activeSidebar } = this.props;
    return activeSidebar === constants.PROMPT_SIDEBAR.OVERVIEW;
  };

  render() {
    const { activeSidebar, history } = this.props;
    let subMenus = [];

    return (
      <MenuItem
        menuId={constants.PROMPT_MENU.OVERVIEW}
        menuName="Overview"
        icon="slider"
        href={this.overviewUrl}
        isActive={this.checkIsActive()}
        subMenus={subMenus}
        {...this.props}
      />
    );
  }
}

@observer
class AnalyticsMenu extends React.Component {
  constructor (props) {
    super(props);
    this.analyticsUrl = paths.getPathPromptAnalyticsDashboard();
  }

  componentDidMount() {
    let isActive = this.checkIsActive();
    if (isActive) {
      this.props.updateActiveMenu(constants.PROMPT_MENU.ANALYTICS);
    }
  }

  checkIsActive = () => {
    const { activeSidebar } = this.props;
    return activeSidebar === constants.PROMPT_SIDEBAR.ANALYTICS;
  };

  render() {
    const { activeSidebar, history } = this.props;
    let subMenus = [];

    return (
      <MenuItem
        menuId={constants.PROMPT_MENU.ANALYTICS}
        menuName="Analytics"
        icon="bar-chart-alt-2"
        href={this.analyticsUrl}
        isActive={this.checkIsActive()}
        subMenus={subMenus}
        {...this.props}
      />
    );
  }
}


@observer
class PromptsMenu extends React.Component {
  constructor (props) {
    super(props);
    this.promptsUrl = paths.getPathPrompts();
  }

  componentDidMount() {
    let isActive = this.checkIsActive();
    if (isActive) {
      this.props.updateActiveMenu(constants.PROMPT_MENU.PROMPTS);
    }
  }

  getSubMenus = () => {
    const { activeSidebar, history } = this.props;
    let subMenus = [{
        display: true,
        id: constants.PROMPT_SIDEBAR.PROMPTS,
        label: "Manage Prompts",
        href: this.promptsUrl,
        onClick: (e) => utils.handleGoTo(e, history, this.promptsUrl),
        isActive: activeSidebar === constants.PROMPT_SIDEBAR.PROMPTS
    }];

    return subMenus;
  };

  checkIsActive = () => {
    return this.getSubMenus().some((subMenu) => subMenu.isActive);
  };

  render() {
    const { activeSidebar, history } = this.props;
    let subMenus = this.getSubMenus();

    return (
      <MenuItem
        menuId={constants.PROMPT_MENU.PROMPTS}
        menuName="Prompts"
        icon="windows"
        isActive={this.checkIsActive()}
        subMenus={subMenus}
        {...this.props}
      />
    );
  }
}



@observer
class ConnectionsMenu extends React.Component {
  constructor (props) {
    super(props);
    this.connectionsUrl = paths.getPathPromptConnections();
  }

  componentDidMount() {
    let isActive = this.checkIsActive();
    if (isActive) {
      this.props.updateActiveMenu(constants.PROMPT_MENU.CONNECTIONS);
    }
  }

  checkIsActive = () => {
    const { activeSidebar } = this.props;
    return activeSidebar === constants.PROMPT_SIDEBAR.CONNECTIONS;
  };

  render() {
    const { activeSidebar, history } = this.props;
    let subMenus = [];

    return (
      <MenuItem
        menuId={constants.PROMPT_MENU.CONNECTIONS}
        menuName="Connections"
        icon="shape-circle"
        href={this.connectionsUrl}
        isActive={this.checkIsActive()}
        subMenus={subMenus}
        {...this.props}
      />
    );
  }
}




@observer
class PromptSidebar extends React.Component {
  constructor (props) {
    super(props);
    this.state = {
      activeMenu: "",
    };
  }

  componentDidMount() {
    auth.setCurrentProduct(constants.PRODUCT_PROMPT);
  }

  updateActiveMenu = (activeMenu) => {
    if (this.state.activeMenu === activeMenu) {
      this.setState({activeMenu: ""});
      return;
    }

    this.setState({activeMenu: activeMenu});
  };

  render() {
    return (
      <div className="sidebar sidebar-prompt">
        <div className="sidebar-head">
          <div className="head-icon"><PromptIcon /></div>
          <div className="head-title">Prompt</div>
        </div>

        <div className="menu-items">
          <div className="menu-group">
            <OverviewMenu
              isActive={this.state.activeMenu === constants.PROMPT_MENU.OVERVIEW}
              updateActiveMenu={this.updateActiveMenu}
              {...this.props}
            />

            <AnalyticsMenu
              isActive={this.state.activeMenu === constants.PROMPT_MENU.ANALYTICS}
              updateActiveMenu={this.updateActiveMenu}
              {...this.props}
            />

            <PromptsMenu
              isActive={this.state.activeMenu === constants.PROMPT_MENU.PROMPTS}
              updateActiveMenu={this.updateActiveMenu}
              {...this.props}
            />

            <EcommerceMenu
              theme={constants.PRODUCT_PROMPT}
              displayProducts={true}
              isActive={this.state.activeMenu === constants.PROMPT_MENU.ECOMMERCE}
              updateActiveMenu={this.updateActiveMenu}
              {...this.props}
            />

            <ConnectionsMenu
              isActive={this.state.activeMenu === constants.PROMPT_MENU.CONNECTIONS}
              updateActiveMenu={this.updateActiveMenu}
              {...this.props}
            />

            <DataMenu
              isActive={this.state.activeMenu === constants.PROMPT_MENU.DATA}
              updateActiveMenu={this.updateActiveMenu}
              {...this.props}
            />
          </div>

          <AdminMenuGroup
            activeMenu={this.state.activeMenu}
            updateActiveMenu={this.updateActiveMenu}
            product={constants.PRODUCT_PROMPT}
            {...this.props}
          />
        </div>
      </div>
    );
  }
}



export { PromptSidebar };

